import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Loader2, Star } from "lucide-react";

export const ContactFormDialog = ({
  open, onOpenChange, editMode, name, setName, email, setEmail,
  salutation, setSalutation, firstName, setFirstName, lastName, setLastName,
  important, setImportant, onSubmit, saving,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent data-testid="contact-form-dialog">
      <DialogHeader>
        <DialogTitle>{editMode ? "Kontakt bearbeiten" : "Kontakt hinzufügen"}</DialogTitle>
        <DialogDescription>Empfängerdaten für personalisierte Anreden ({"{{Anrede}}, {{Vorname}}"}).</DialogDescription>
      </DialogHeader>
      <form onSubmit={onSubmit}>
        <div className="py-2 space-y-4">
          <div className="space-y-2">
            <Label htmlFor="contact-name">Name (Anzeigename)</Label>
            <Input id="contact-name" value={name} onChange={(e) => setName(e.target.value)} placeholder="z. B. Dr. Anna Schaum" data-testid="contact-name-input" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="contact-email">E-Mail *</Label>
            <Input id="contact-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="contact-email-input" />
          </div>
          <div className="grid grid-cols-3 gap-3">
            <div className="space-y-2">
              <Label htmlFor="contact-salutation">Anrede</Label>
              <Select value={salutation || "none"} onValueChange={(v) => setSalutation(v === "none" ? "" : v)}>
                <SelectTrigger id="contact-salutation" data-testid="contact-salutation-select">
                  <SelectValue placeholder="—" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="none">—</SelectItem>
                  <SelectItem value="Herr">Herr</SelectItem>
                  <SelectItem value="Frau">Frau</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div className="space-y-2">
              <Label htmlFor="contact-first">Vorname</Label>
              <Input id="contact-first" value={firstName} onChange={(e) => setFirstName(e.target.value)} data-testid="contact-firstname-input" />
            </div>
            <div className="space-y-2">
              <Label htmlFor="contact-last">Nachname</Label>
              <Input id="contact-last" value={lastName} onChange={(e) => setLastName(e.target.value)} data-testid="contact-lastname-input" />
            </div>
          </div>
          <p className="text-xs text-muted-foreground -mt-1">Leer lassen = automatisch aus dem Namen abgeleitet.</p>
          <button
            type="button"
            onClick={() => setImportant(!important)}
            className={`flex items-center gap-2 w-full rounded-lg border p-3 text-sm text-left transition-colors ${important ? "border-amber-300 bg-amber-50 text-amber-800" : "border-border hover:bg-muted/40"}`}
            data-testid="contact-important-toggle"
          >
            <Star className={`w-4 h-4 ${important ? "fill-amber-400 text-amber-500" : "text-muted-foreground"}`} />
            <span>
              <span className="font-medium">Wichtiger Lead</span>
              <span className="block text-xs opacity-80">Benachrichtigung, sobald diese Person eine Mail öffnet (ab Phase 4).</span>
            </span>
          </button>
        </div>
        <DialogFooter>
          <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>Abbrechen</Button>
          <Button type="submit" disabled={saving} data-testid="contact-save-btn">
            {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : "Speichern"}
          </Button>
        </DialogFooter>
      </form>
    </DialogContent>
  </Dialog>
);
